import {
  isProductReviewed,
  markProductReviewed,
  resetReviewedMarks,
  unmarkProductReviewed,
} from '../utils/myReviews'

/**
 * Товары, на которые покупатель оставил отзыв в этой сессии. В заказах `reviewId` приходит
 * с сервера при загрузке страницы; после отправки формы список заказов не перезапрашивается
 * (его страницы склеиваются вручную), поэтому «Оценить товар» сменяется на «Мой отзыв»
 * по этой отметке — сразу во всех позициях товара. Удаление отзыва снимает отметку,
 * выход и вход — сбрасывают все (плагин reviewedNowReset).
 */
export function useReviewedNow() {
  const reviewed = useState<number[]>('reviews:reviewed-now', resetReviewedMarks)

  return {
    /** Есть ли отзыв на товар: с сервера (`reviewId`) или оставлен в этой сессии */
    isReviewed: (productId: number, reviewId: number | null | undefined) =>
      isProductReviewed(reviewed.value, productId, reviewId),
    markReviewed(productId: number) {
      reviewed.value = markProductReviewed(reviewed.value, productId)
    },
    markRemoved(productId: number) {
      reviewed.value = unmarkProductReviewed(reviewed.value, productId)
    },
    reset() {
      reviewed.value = resetReviewedMarks()
    },
  }
}
